import React from 'react';
import { Select, SelectProps } from 'tea-component';
import { connect } from 'umi';
import { TOptionsItem, ISingleCommonType } from '../../types';
import useIntls from '@opm/hooks/useIntls';
import { singleMapStateToProps, singleMergeProps } from '../../connect/single';
import { SingleSelectButton, renderOptionItem } from './SingleSelectButton';

export type TSingleSelectType = {
  options: TOptionsItem[];
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element;
  valueKeys: string;
  title: string;
  titleCn: string;
  filterClassName?: string;
  instanceId?: string;
} & Omit<SelectProps, 'options'>;

// 这个是纯组件
export function SingleSelect({
  options,
  itemRender,
  change,
  value,
  title,
  titleCn,
  filterClassName,
  ...props
}: TSingleSelectType & ISingleCommonType) {
  const { isEn } = useIntls();

  return (
    <div className={`dbom-multiple-select-wrapper ${filterClassName}`}>
      <Select
        matchButtonWidth
        appearance="button"
        options={options.map((item) => ({
          ...item,
          text: renderOptionItem(item, isEn, itemRender),
        }))}
        button={() => (
          <SingleSelectButton
            value={value}
            options={options}
            title={title}
            titleCn={titleCn}
            itemRender={itemRender}
          />
        )}
        listHeight={390}
        value={value}
        onChange={(value) => change(value)}
        {...props}
      />
    </div>
  );
}

// 自带值，和修改方法
export default connect(singleMapStateToProps, singleMergeProps)(SingleSelect);
